import React from "react";
import { CheckboxField } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";

const UrgentField = React.memo(() => (
  <CheckboxField
    name={fieldTypes.URGENT}
    label={translate(null, "care_team_tasks.form.fields.urgent", "label")}
  />
));

export default UrgentField;
